import React from 'react';
import { useNavigate } from 'react-router-dom';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { tA11y } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { ButtonProps } from './Button';
import IconButton from './IconButton';

const BackButton: React.FC<ButtonProps> = (props) => {
  const navigate = useNavigate();

  const handleClick = (e: any) =>
    props.redirectRoute ? e.stopPropagation() : props.onClick ? props.onClick?.(e) : navigate(-1);

  return (
    <IconButton
      icon={faArrowLeft}
      onClick={handleClick}
      aria-label={tA11y('buttons.backButton')}
      color="inherit"
      {...props}
    ></IconButton>
  );
};

export default BackButton;
